import { createAsyncThunk } from "@reduxjs/toolkit";
import { invoiceAPI } from "../../helpers/api/invoice"

export const createInvoice = createAsyncThunk(
  "smartbill/createInvoice",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await invoiceAPI.createInvoice(requestData);
      return response.data;
    } catch (error) {
      // Backend error shape: { "error": { "code": ..., "message": ..., "details": ... } }
      const backendError = error.response?.data?.error;
      let message;

      if (backendError) {
        message = backendError.message || `API Error: ${error.response.status}`;
        console.error('SmartBill API Error Response:', error.response.data);
      } else if (error.request) {
        message = 'Network error - please check your connection';
      } else {
        message = error.message || 'Unknown error occurred';
      }

      return rejectWithValue({
        message,
        code: backendError?.code || null,
        details: backendError?.details || null,
      });
    }
  }
);

export const linkInvoice = createAsyncThunk(
  "smartbill/linkInvoice",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await invoiceAPI.linkInvoice(requestData);
      return response;
    } catch (error) {
      // Backend error shape: { "error": { "code": ..., "message": ..., "details": ... } }
      const backendError = error.response?.data?.error;

      return rejectWithValue({
        message: backendError?.message || error.message || 'Failed to link invoice',
        code: backendError?.code || null,
        details: backendError?.details || null,
        status: error.response?.status,
      });
    }
  }
);

export const unlinkInvoice = createAsyncThunk(
  "smartbill/unlinkInvoice",
  async (paymentId, { rejectWithValue }) => {
    try {
      const response = await invoiceAPI.unlinkInvoice(paymentId);
      return response;
    } catch (error) {
      // Backend error shape: { "error": { "code": ..., "message": ..., "details": ... } }
      const backendError = error.response?.data?.error;

      return rejectWithValue({
        message: backendError?.message || error.message || 'Failed to unlink invoice',
        code: backendError?.code || null,
        details: backendError?.details || null,
        status: error.response?.status,
      });
    }
  }
);

export const unlinkInvoiceById = createAsyncThunk(
  "smartbill/unlinkInvoiceById",
  async (invoiceId, { rejectWithValue }) => {
    try {
      const response = await invoiceAPI.unlinkInvoiceById(invoiceId);
      return response;
    } catch (error) {
      // Backend error shape: { "error": { "code": ..., "message": ..., "details": ... } }
      const backendError = error.response?.data?.error;

      return rejectWithValue({
        message: backendError?.message || error.message || 'Failed to unlink invoice',
        code: backendError?.code || null,
        details: backendError?.details || null,
        status: error.response?.status,
      });
    }
  }
);
